/* eslint-disable no-case-declarations */
import { findNode, TreeBrowserMachineEvent, TreeBrowserMachineEventType, TreeBrowserNode, TreeBrowserQueryString, TreeBrowserState } from "@iventis/tree-browser";

export const libraryURLStateMiddleware = <TNode extends TreeBrowserNode>(state: TreeBrowserState<TNode>, event: TreeBrowserMachineEvent<TNode>) => {
    const searchParams = new URLSearchParams(window.location.search);
    const { tree, mainNodeId, expandedNodeIds } = state;

    switch (event.type) {
        case TreeBrowserMachineEventType.TOGGLE_EXPAND_NODE:
            settingOpenNode(searchParams, tree, expandedNodeIds, event.payload.node.id);
            break;
        case TreeBrowserMachineEventType.SET_MAIN_NODE:
        case TreeBrowserMachineEventType.SET_TREE:
            isOpenNodeInTree(searchParams, state.tree, event.payload.id);
            settingMainNode(searchParams, mainNodeId);
            break;
        default:
    }

    // Creates new url with search params and replaces it
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
};

const settingMainNode = (searchParams: URLSearchParams, mainNodeId: string) => {
    searchParams.set(TreeBrowserQueryString.MAIN_NODE_ID, mainNodeId);
};

const settingOpenNode = <TNode extends TreeBrowserNode>(searchParams: URLSearchParams, tree: TNode, expandedNodeIds: string[], toggledNodeId: string) => {
    const isNodeOpen = expandedNodeIds.includes(toggledNodeId);
    const openNodeId = isNodeOpen ? toggledNodeId : findNode([tree], toggledNodeId).parentId;
    searchParams.set(TreeBrowserQueryString.EXPANDED_NODE_ID, openNodeId);
};

/**
 * Checks if the open node id in the url is in the current tree
 * If node is not in tree it deletes it from the search params
 */
const isOpenNodeInTree = <TNode extends TreeBrowserNode>(searchParams: URLSearchParams, tree: TNode, mainNodeId: string) => {
    const nodeTree = findNode([tree], mainNodeId);
    const isNodePresent = findNode([nodeTree], searchParams.get(TreeBrowserQueryString.EXPANDED_NODE_ID));
    if (!isNodePresent) {
        searchParams.delete(TreeBrowserQueryString.EXPANDED_NODE_ID);
    }
};
